import { getLogger } from '../diagnostics/logger';
import moment from 'moment';
import { Action, ActionMeta } from '../actions';
import {
  LOAD_PORT_NETWORKS_FAILURE,
  LOAD_PORT_NETWORKS_PENDING,
  LOAD_PORT_NETWORKS_SUCCESS,
} from '../actions/actionTypes';
import { DropdownItem } from '../components/ui/input/DropdownInput';
import { SimManagementError } from '../models/Errors';
import { initialAppState } from '../models/state/appState';
import { TariffsStateCacheTimeout } from '../models/state/simProvision/cacheTimeouts';
import { getDefaultDropdownItems } from '../models/state/simProvision/defaults';
import { DropdownItems, DropdownItemsState } from '../models/state/simProvision/simProvisionState';
const log = getLogger('simManagement.reducers.portNetworksReducer');

export default function portNetworkReducer(
  state: DropdownItemsState = initialAppState.portNetworks,
  action: any,
): DropdownItemsState {
  switch (action.type) {
    case LOAD_PORT_NETWORKS_PENDING: {
      const typedAction = action as Action<number>;
      const { payload } = typedAction;
      if (!payload) {
        log.warn('No payload');
        return state;
      }

      const networkId = payload;
      const items: DropdownItems = {
        ...getDefaultDropdownItems(),
        isLoading: true,
      };

      const changedState: DropdownItemsState = {};
      changedState[networkId] = items;

      const newState = Object.assign({}, state, changedState);
      return newState;
    }
    case LOAD_PORT_NETWORKS_FAILURE: {
      const typedAction = action as ActionMeta<number, SimManagementError>;
      const { meta, payload } = typedAction;
      if (!payload) {
        log.warn('No payload');
        return state;
      }

      if (!meta) {
        log.warn('No meta');
        return state;
      }

      const networkId = payload;
      const items: DropdownItems = {
        ...getDefaultDropdownItems(),
        error: meta,
      };

      const changedState: DropdownItemsState = {};
      changedState[networkId] = items;

      const newState = Object.assign({}, state, changedState);
      return newState;
    }
    case LOAD_PORT_NETWORKS_SUCCESS: {
      const typedAction = action as ActionMeta<number, DropdownItem[]>;
      const { meta, payload } = typedAction;
      if (!payload) {
        log.warn('No payload');
        return state;
      }

      if (!meta) {
        log.warn('No meta');
        return state;
      }

      const networkId = payload;
      const portTargetNetworks = meta;
      const items: DropdownItems = {
        ...getDefaultDropdownItems(),
        items: [...portTargetNetworks],
        byId: Object.assign({}, ...portTargetNetworks.map((a: any) => ({
          [a.key]: a
        }))),
        expiresOn: moment().add(TariffsStateCacheTimeout, 'seconds').toDate(),
      };

      const changedState: DropdownItemsState = {};
      changedState[networkId] = items;

      const newState = Object.assign({}, state, changedState);
      return newState;
    }
    default:
      return state;
  }
}
